



import Vue from 'vue'
import Poll from '@/models/polls/Poll'
import statusComponent from '@/components/polls/status.vue'

export default Vue.extend({
  name: 'TextColumn',
  props: {
    row: Object as () => Poll
  },
  components: {
    statusComponent
  }
})
